import { localize } from "client_legacy/ndaw/culture";
import { AlertDialog, Anchor, FormattedText } from "client/Components";
import { ReactElement } from "react";

export type UpdateSuccessDialogProps = {
	consentUrl: string | null;
	onClose: () => void;
};

export const UpdateSuccessDialog = (props: UpdateSuccessDialogProps): ReactElement => {
	const { onClose, consentUrl } = props;

	return (
		<AlertDialog
			title={localize("_Success")}
			onClose={onClose}
			confirmText={localize("_Ok")}
			trackingId="update-success-dialog"
		>
			{localize("_SingleSignOnAppHasBeenSuccessfullyUpdated")}
			<br />
			<br />
			{consentUrl && (
				<FormattedText
					text={localize("_ClickHereToGrantAdminConsentForThePermissionsWithinTheApplication")}
					thingsToReplace={
						[
							{
								what: "{{ClickHere}}",
								filler: <Anchor href={consentUrl} target="_blank">{localize("_ClickHere")}</Anchor>
							}
						]
					}
				/>
			)}
		</AlertDialog>
	);
};

UpdateSuccessDialog.displayName = "UpdateSuccessDialog";
